import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Bind from 'lodash-decorators/bind';
import PropTypes from 'prop-types';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import { observer } from 'mobx-react';

import styles from './Header.module.scss';

import messages from './Header.intl';

import logo from 'common/images/logo_th_dark.svg';

import { Container } from 'common/components/Layout/Layout';

import CollapsedMenu from './components/CollapsedMenu/CollapsedMenu';

import { ANCHOR } from 'common/consts/common';

import LanguageService from 'services/Language.service';

@injectIntl
@observer
export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false
    };
  }

  static propTypes = {
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  currentLanguage = LanguageService.getLang();

  render() {
    const { className } = this.props;
    const { isOpened } = this.state;
    return (
      <div className={`${className} ${styles.Header}`}>
        <Container>
          <div className={styles.HeaderContent}>
            <div className={styles.HeaderLogo}>
              <Link to="/">
                <img
                  src={logo}
                  className={styles.HeaderLogo}
                  alt="TH-newLogo"
                />
              </Link>
            </div>
            <div className={styles.NavWrapper}>
              <Link
                to={ANCHOR.FOR_INVESTORS[this.currentLanguage]}
                className={styles.NavItem}
              >
                <span>
                  {this.props.intl.formatMessage(messages.textForInvestors)}
                </span>
              </Link>
              <div className={styles.HeaderToggler} onClick={this.openMenu}>
                <p>Menu</p>
                <div className={styles.HeaderTogglerIcon}>
                  <div className={styles.HeaderTogglerBar} />
                  <div className={styles.HeaderTogglerBar} />
                  <div className={styles.HeaderTogglerBar} />
                </div>
              </div>
              {isOpened && <CollapsedMenu onClose={this.closeMenu} />}
            </div>
          </div>
        </Container>
      </div>
    );
  }

  @Bind()
  openMenu() {
    this.setState({
      isOpened: true
    });
  }

  @Bind()
  closeMenu() {
    this.setState({
      isOpened: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/components/Header/Header.js